import { useEffect, useRef } from 'react';

/**
 * StructuredData component for adding JSON-LD schema markup
 * Directly injects script tags into <head> to avoid react-helmet-async
 * serialization issues with JSON-LD content.
 * 
 * @param {Object} props
 * @param {Object|Array} props.data - Schema.org structured data object(s)
 */
const StructuredData = ({ data }) => {
  const scriptRefs = useRef([]);

  useEffect(() => {
    const schemaArray = (Array.isArray(data) ? data : [data]).filter(Boolean);

    // Clean up any previously injected scripts from this component instance
    scriptRefs.current.forEach(script => script.remove());
    scriptRefs.current = [];

    schemaArray.forEach(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptRefs.current.push(script);
    });

    return () => {
      scriptRefs.current.forEach(script => script.remove());
      scriptRefs.current = [];
    };
  }, [data]);

  return null;
};

export default StructuredData;


